<div class="container-fluid admin-page airport-kiosk-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Airport kiosk' | translate }}</h1>
            <p>{{ 'Manage the airport kiosk and inspect its latest system logs.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            @if (canRestartKiosk) {
            <button (click)="restartKiosk()" [disabled]="isRunningAction"
                    class="admin-primary-button" type="button">
                <i class="material-icons">power_settings_new</i>
                <span>{{ (isRunningAction ? 'Restarting...' : 'Restart Kiosk') | translate }}</span>
            </button>
            }
            @if (canViewLogs) {
            <button (click)="loadLogs()" [disabled]="isLoadingLogs"
                    class="admin-refresh-button" type="button">
                <i class="material-icons">refresh</i><span>{{ 'Refresh' | translate }}</span>
            </button>
            }
        </div>
    </header>

    @if (actionMessage) {
        <div class="action-message">{{ actionMessage | translate }}</div>
    }

    @if (canViewLogs) {
    <section class="logs-panel">
        <div class="logs-header">
            <div>
                <span class="section-label">{{ 'SSH Logs' | translate }}</span>
                <h3>{{ 'Recent kiosk logs' | translate }}</h3>
            </div>
            <div class="logs-tools">
                <span>{{ logsMeta | translate }}</span>
            </div>
        </div>
        <pre class="logs-output">{{ logsText | translate }}</pre>
    </section>
    }
</div>
